export default class PurchaseBookingService {

    constructor(BBModel) {
        this.BBModel = BBModel;
    }

    /**
     * @ngdoc method
     * @name update
     * @methodOf BBPublicBooking.PurchaseBookingService
     *
     * @description
     * Updates given model object.
     *
     * @param {object} model Booking model object.
     * @param {object} data Post data that will be sent to server.
     * @param {object} options Additional options sent to server (will override any data used in data parameter).
     *
     * @returns {object} PurchaseBooking model object that has been updated.
     */
    update(model, data, options = {}) {
        return model.$put('self', {}, Object.assign({}, data, options))
            .then((booking) => {
                return Promise.resolve(new this.BBModel.Purchase.Booking(booking));
            });
    }

}

angular.module('BBPublicBooking').service('PurchaseBookingService', PurchaseBookingService);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/purchase/_services/purchase_booking.service.js